import { profile } from "../../data/resume";

export const Footer = () => {
  return (
    <footer data-testid="main-footer" className="bg-ink text-white py-14">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8">
          <div className="flex items-center gap-3">
            <span className="flex items-center justify-center h-10 w-10 bg-brass text-ink font-serif font-bold">
              DH
            </span>
            <div>
              <div className="font-serif font-semibold text-lg">{profile.name}</div>
              <div className="text-sm text-slate-400">{profile.title}</div>
            </div>
          </div>

          <div className="flex flex-wrap gap-x-8 gap-y-2 text-sm text-slate-300">
            <a href={`mailto:${profile.email}`} className="hover:text-brass transition-colors" data-testid="footer-email">{profile.email}</a>
            <a href={profile.phoneHref} className="hover:text-brass transition-colors" data-testid="footer-phone">{profile.phone}</a>
            <a href={profile.linkedinHref} target="_blank" rel="noopener noreferrer" className="hover:text-brass transition-colors" data-testid="footer-linkedin">LinkedIn</a>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-white/10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 text-sm text-slate-500">
          <p>© {new Date().getFullYear()} {profile.name}. All rights reserved.</p>
          <p>{profile.location} · {profile.credentials}</p>
        </div>
      </div>
    </footer>
  );
};
